<template lang="pug">
  SspLayout(area="tnt")
    form.panel.panel-default(role="form" @submit.prevent="receive")
      .panel-heading
        h3.panel-title Shipment
          |
          |
          a(:href="`#/trackntrace/shipment/${shipment.id}/view`") {{shipment.id}}
          span
          |
          | is {{shipment.status}}
      .panel-body
        .row
          label.col-md-2 Target location
          .col-md-3 {{shipment.targetLocation ? shipment.targetLocation.name : ''}}
        .row
          label.col-md-2 Size
          .col-md-3 {{shipment.size}}
        .row
          label.col-md-2 Created
          .col-md-3 {{shipment.created | date}}
        .row(ng-show="shipment.approved")
          label.col-md-2 Approved
          .col-md-3 {{shipment.approved | date}}
        .row(ng-show="shipment.closed")
          label.col-md-2 Closed
          .col-md-3 {{shipment.closed | date}}
        .row(ng-show="shipment.shipped")
          label.col-md-2 Shipped
          .col-md-3 {{shipment.shipped | date}}
        .row.col-md-12(v-if='shipment.status !== "SHIPPED"')
          div Only shipments with status 'SHIPPED' can be received
        .row(v-if='shipment.status === "SHIPPED"')
          .col-md-2
            LocationPicker.received-location(v-model="location")
          .col-md-2
            SspActionButton(type="submit" icon="flag" text="Receive" :disabled="!location")
</template>

<script>
import miniToastr from 'mini-toastr'
import { dateFilter } from '@/filters/filters'
import TrackNTrace from '@/service/apis/TrackNTrace'
import LocationPicker from '@/components/ssp/LocationPicker'

export default {
  data: () => ({
    recieving: false,
    shipment: {},
    location: null
  }),
  created() {
    this.load()
  },
  methods: {
    load() {
      TrackNTrace.findShipmentByCode(this.code)
        .then((r) => {
          this.shipment = r.data
        })
        .catch((e) => { this.$emit('error', e) })
      TrackNTrace.listBusinessLocations()
        .then((r) => {
          if (r.data.content.length === 1) {
            const [location] = r.data.content
            this.location = location
          }
        })
        .catch((e) => { this.$emit('error', e) })
    },
    receive() {
      this.recieving = true
      TrackNTrace.receiveShipment({ location: { id: this.location.id }, shipment: { id: this.shipment.id } })
        .then(() => {
          miniToastr.success('Shipment received')
          this.load()
        })
        .catch((e) => { this.$emit('error', e) })
        .then(() => {
          this.recieving = false
        })
    }
  },
  computed: {
    code() {
      return this.$route.params.code
    }
  },
  filters: {
    date: dateFilter
  },
  components: {
    LocationPicker
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/shipments/ReceiveShipment.vue